import React from "react";
import "./PdfContent.scss";
import { useParams } from 'react-router-dom';

const VoicePhotoPrivacyContent = () => {
  let tag = {
    62580:{appName:"62580",companyName:"强生致行互联网科技（上海）有限公司"},
    ddcx:{appName:"叮叮出行",companyName:"重庆庞大叮叮科技有限公司南京分公司"},
    ydyc:{appName:"悦道用车",companyName:"上海美跃信息技术有限公司"},
    qxcx:{appName:"前行出行",companyName:"前行无限(天津)科技有限公司"},
    tgcx:{appName:"同港出行",companyName:"重庆渐臻科技有限公司"},
  }
  const params = useParams();
  const routeTag = params.tag;
  let currentTag = routeTag || "62580";
  let appName = tag[currentTag].appName;
  let companyName = tag[currentTag].companyName;
  
  return (
    <div className="pdf-container">
      <div className="pdf-content">
        <h1 className="title">{appName}录音录像信息收集及隐私保护协议</h1>
        
        <p className="pdf-paragraph">
          为提升{appName}平台服务产品安全能力及服务品质、更好地处理司乘纠纷，{appName}平台上线录音录像功能。如车辆内未安装具备录像功能的车载硬件设备，我们将无法收集录像信息，本协议有关录像的内容对您不予适用。本协议将向您说明{appName}平台网约车服务收集使用录音录像信息的情况，请您务必认真阅读本协议，在确认充分了解后慎重决定是否同意本协议。您同意本协议后，本协议生效，对您及{appName}平台均具有法律约束力。
        </p>

        <h1 className="pdf-main-title">1. 录音录像信息收集</h1>
        
        <p className="pdf-paragraph">
          您同意本协议后，使用{appName}平台提供的网约车服务时，{appName}平台将通过司机使用的{appName}司机APP及车载硬件设备（例如部分车辆安装了DVR设备）录取您后续全部行程中的车内及/或车外环境声音及/或视频信息（包括您及车上人员交谈或肢体动作产生的声音及/或画面）。受技术条件影响，{appName}平台各项服务在不同城市或区域上线录音及/或录像功能的时间不同，具体以{appName}平台内提示的信息为准。
        </p>

        <h1 className="pdf-main-title">2. 录音录像开启条件</h1>
        
        <p className="pdf-paragraph">
          录音录像仅在司机、乘客均同意的情况下开启。如您使用的App版本未及时更新，无法对录音录像进行授权，则录音录像不开启。
        </p>

        <h1 className="pdf-main-title">3. 录音录像起始时间</h1>
        
        <p className="pdf-paragraph">
          a）乘客自进入车辆后至离开车辆时，将被采集车内录音及/或录像信息。并且，自车辆启动至熄火前，车外环境声音及/或视频信息将进行录取。您行程中的车外环境声音及/或视频信息可能被用于处理用户纠纷及其他与司乘人身安全相关的纠纷。
        </p>
        
        <p className="pdf-paragraph">
          b）其他上线录音录像功能的服务的录音起始时间以{appName}APP另行告知为准。
        </p>

        <h1 className="pdf-main-title">4. 代叫车及同乘须知</h1>
        
        <p className="pdf-paragraph">
          如您是代他人叫车或是与他人一同乘车，在代叫车前或共同进入车辆前请务必告知被代叫车人、同乘人行程内录音录像信息收集情况，并征得被代叫车人、同乘人同意后，才可叫车、上车。
        </p>

        <h1 className="pdf-main-title">5. 录音录像信息使用场景</h1>
        
        <p className="pdf-paragraph">
          录音录像信息将用于以下明确列明的使用场景：
        </p>
        
        <h2 className="pdf-clause-title">
          a）作为{appName}平台、{appName}司机平台处理用户纠纷的依据；
        </h2>
        
        <h2 className="pdf-clause-title">
          b）为维护用户人身安全等重大合法利益，或情况紧急又很难获得用户同意时；
        </h2>
        
        <h2 className="pdf-clause-title">
          c）用于抽查、检测、核实用户是否存在违反平台规则的行为；
        </h2>
        
        <h2 className="pdf-clause-title">
          d）用于系统分析，设计、开发、应用保护用户安全的辅助工具或产品；
        </h2>
        
        <h2 className="pdf-clause-title">
          e）用于抽查、监测、核实司机的服务品质；
        </h2>
        
        <h2 className="pdf-clause-title">
          f）另行征得您单独同意的场景或者法律法规规定的其他无需征得您同意的场景。
        </h2>

        <h1 className="pdf-main-title">6. 录音录像信息共享</h1>
        
        <p className="pdf-paragraph">
          除以下情况外，{appName}平台不会向其他人共享您的录音及/或录像信息：
        </p>
        
        <h2 className="pdf-clause-title">
          a. 司法机关、政府机关、监管部门依据法定程序调取；
        </h2>
        
        <h2 className="pdf-clause-title">
          b. 录音及/或录像相关的乘客、司机或其他相关人员持法律文件依法调取；
        </h2>
        
        <h2 className="pdf-clause-title">
          c. 为实现《{appName}隐私政策》中关于"个人信息的对外提供、公开披露与委托处理"的目的向我们的关联方、合作伙伴或代表我们履行某项职能的第三方（统称为"相关第三方机构"）共享该等信息；
        </h2>
        
        <h2 className="pdf-clause-title">
          d. 某些情况下，只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议；
        </h2>
        
        <h2 className="pdf-clause-title">
          e. 取得您单独同意的；
        </h2>
        
        <h2 className="pdf-clause-title">
          f. 为应对突发公共卫生事件，或者紧急情况下为保护您或其他自然人的生命健康和财产安全所必需；
        </h2>
        
        <h2 className="pdf-clause-title">
          g. 根据法律法规的规定必须向第三方提供的。
        </h2>

        <h1 className="pdf-main-title">7. 录音录像信息的存储</h1>
        
        <h2 className="pdf-clause-title">
          a）录音会存储在服务器，存储时间不超过7天，但本协议另有约定的情形除外；
        </h2>
        
        <h2 className="pdf-clause-title">
          b）录像会在车载硬件设备（例如当车辆安装了DVR设备时）中保存，录像在车载硬件设备内的保存期限受设备内存容量限制，当存储空间已满时会自动删除最早的录像，但本协议另有约定的其他情形除外；
        </h2>
        
        <h2 className="pdf-clause-title">
          c）多日接送服务中，为保证车内安全，行程录像会上传存储在服务器供您远程查看。如您或实际乘车人不同意，或您未告知并征得实际乘车人同意，请勿使用多日接送服务；
        </h2>
        
        <h2 className="pdf-clause-title">
          d）在紧急状况下或基于处理纠纷之需要，我们会将录音及/或录像信息保存更长时间，保存期限以处理相关事件所需时间为准。
        </h2>

        <h1 className="pdf-main-title">8. 免责条款</h1>
        
        <p className="pdf-paragraph">
          用户使用的手机、车载硬件设备故障、网络状态不稳定、APP版本过旧、APP故障或异常、车辆未安装相应硬件设备以及不可抗力等因素均可能导致录音及/或录像失败、不全面或无法进行录音及/或录像，您对此表示理解，如遇此类问题，{appName}平台不需承担责任。
        </p>

        <h1 className="pdf-main-title">9. 其他条款</h1>
        
        <p className="pdf-paragraph">
          {appName}平台将严格按照本协议约定收集使用用户录音录像信息。本协议对相关内容未作明确约定的，以{appName}平台《{appName}隐私政策》约定为准。如您对本协议及隐私政策有任何问题，可以拨打{appName}平台客服热线进行询问，或联系个人信息保护负责人邮箱，我们会在15日内或法律规定的期限内响应您的请求。
        </p>
        
        <p className="pdf-paragraph">
          发布日期：【2023】年【10】月【24】日
        </p>
        <p className="pdf-paragraph">
          生效日期：【2023】年【10】月【31】日
        </p>
      </div>
    </div>
  );
};

export default VoicePhotoPrivacyContent;
